/**
 * Chart chrome colours, one pair per theme.
 *
 * "Ink" is everything the chart draws that is NOT data: axis lines, tick labels, the plot frame,
 * in-plot text, the hover crosshair. Series colours are user configuration and never live here.
 *
 * Ported from Alinghi for RACE SUMMARY D3 panels (DtlChart, RaceCourseView).
 */

import { isDark } from "../store/themeStore";

export interface ChartInk {
  axis: string;
  grid: string;
  label: string;
  frame: string;
  crosshair: string;
  brushFill: string;
  brushStroke: string;
  pointRing: string;
}

const DARK_INK: ChartInk = {
  axis: "#e5e5e5",
  grid: "rgba(255,255,255,0.18)",
  label: "#ffffff",
  frame: "#e5e5e5",
  crosshair: "rgba(255,255,255,0.95)",
  brushFill: "rgba(211,211,211,0.28)",
  brushStroke: "rgba(255,255,255,0.4)",
  pointRing: "#ffffff",
};

const LIGHT_INK: ChartInk = {
  axis: "#333",
  grid: "rgba(0,0,0,0.2)",
  label: "#111111",
  frame: "#333",
  crosshair: "rgba(0,0,0,0.75)",
  brushFill: "rgba(70,90,120,0.18)",
  brushStroke: "rgba(0,0,0,0.35)",
  pointRing: "#111111",
};

/**
 * Ink for the current theme. `medium` and `dark` are both dark grounds — `isDark()` covers both.
 */
export function chartInk(dark: boolean = isDark()): ChartInk {
  return dark ? DARK_INK : LIGHT_INK;
}
